<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="유해인자 기본정보" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <q-btn
                  v-if="!popupParam.hazardCd"
                  icon="help"
                  color="deep-purple-6"
                  text-color="white"
                  class="custom-btn"
                  align="center"
                  round>
                  <q-tooltip anchor="bottom left" self="top left">
                    <div class="tooltipCustom">
                    물리적인자 선택 시, Cas No.는 입력할 수 없습니다.
                    <br>
                    화학적인자 선택 시, Cas No.의 돋보기 클릭 시 환경부-화학물질정보에서 선택할 수 있습니다.
                    </div>
                  </q-tooltip>
                </q-btn>
                <c-btn
                  v-if="editable"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="data"
                  :mappingType="mappingType"
                  label="저장"
                  icon="save"
                  @beforeAction="saveData"
                  @btnCallback="saveCallback" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                <c-select
                  required
                  :editable="editable"
                  codeGroupCd="HAZARD_CLASS_FST_CD"
                  type="edit"
                  :disabled="updateMode"
                  itemText="codeName"
                  itemValue="code"
                  name="hazardClassFstCd"
                  label="유해인자 대분류"
                  v-model="data.hazardClassFstCd"
                  @datachange="datachange"
                ></c-select>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                <c-select
                  :comboItems="occSecItems"
                  :disabled="updateMode"
                  :editable="editable"
                  type="edit"
                  itemText="codeName"
                  itemValue="code"
                  name="hazardClassSecCd"
                  label="유해인자 중분류"
                  v-model="data.hazardClassSecCd"
                ></c-select>
              </div>
              <!-- { name: 'close', click: true, callbackName: 'removeHazard', color: 'red' } -->
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                <!-- <c-text
                  :editable="editable"
                  label="CAS NO."
                  :disabled="true"
                  name="casNo"
                  :placeholder="data.hazardClassFstCd === 'HCF0000005' || data.hazardClassFstCd === 'HCF0000010' ? '' : '입력할 수 없음'"
                  v-model="data.casNo"
                  :close="false"
                  :afterIcon="editable && data.hazardClassFstCd === 'HCF0000005' || data.hazardClassFstCd === 'HCF0000010'? [
                    { name: 'search', click: true, callbackName: 'searchHazard', color: 'teal' },
                    { name: 'close', click: true, callbackName: 'removeHazard', color: 'red' }
                    ] : null"
                  @searchHazard="addApiRow"
                  @removeHazard="removeHazard">
                </c-text> -->
                <c-text
                  :editable="editable"
                  label="CAS NO."
                  name="casNo"
                  :placeholder="data.hazardClassFstCd === 'HCF0000005' || data.hazardClassFstCd === 'HCF0000010' ? '' : '입력할 수 없음'"
                  v-model="data.casNo">
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <!-- <c-text
                  :editable="editable"
                  :disabled="true"
                  :placeholder="data.hazardClassFstCd === 'HCF0000005' ||  data.hazardClassFstCd === 'HCF0000010' ? '' : '입력할 수 없음'"
                  label="화학물질명"
                  name="chemName"
                  v-model="data.chemName">
                </c-text> -->
                <c-text
                  :editable="editable"
                  :placeholder="data.hazardClassFstCd === 'HCF0000005' ||  data.hazardClassFstCd === 'HCF0000010' ? '' : '입력할 수 없음'"
                  label="화학물질명"
                  name="chemName"
                  v-model="data.chemName">
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <c-text
                  required
                  :editable="editable"
                  label="유해인자명"
                  name="hazardName"
                  v-model="data.hazardName">
                </c-text>
              </div>
              <!-- <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                <c-text
                  required
                  :editable="editable"
                  :disabled="true"
                  label="유해인자코드"
                  name="hazardCd"
                  v-model="data.hazardCd">
                </c-text>
              </div> -->
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                <c-select
                  codeGroupCd="WORK_MEAS_CYCLE_CD"
                  type="edit"
                  itemText="codeName"
                  itemValue="code"
                  name="workMeasCycleCd"
                  :editable="editable"
                  label="작업환경측정 주기"
                  v-model="data.workMeasCycleCd"
                  @datachange="datachange1"
                ></c-select>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                <c-select
                  codeGroupCd="WORK_MEAS_CYCLE_CD"
                  :editable="editable"
                  type="edit"
                  itemText="codeName"
                  itemValue="code"
                  name="factorMeasCycleCd"
                  label="특수건강검진 주기"
                  v-model="data.factorMeasCycleCd"
                  @datachange="datachange2"
                ></c-select>
              </div>
              <!-- <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                <c-radio
                  :editable="editable"
                  :comboItems="workFlagItems"
                  label="작업환경측정 관련 여부"
                  name="workEnvFlag"
                  v-model="data.workEnvFlag">
                </c-radio>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                <c-radio
                  :editable="editable"
                  :comboItems="workFlagItems"
                  label="특수건강검진 관련 여부"
                  name="speHealthFlag"
                  v-model="data.speHealthFlag">
                </c-radio>
              </div> -->
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                <c-radio
                  :editable="editable"
                  :comboItems="useFlagItems"
                  label="사용여부"
                  name="useFlag"
                  v-model="data.useFlag">
                </c-radio>
              </div>
            </template>
          </c-card>
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
          <c-table
            ref="subsTable"
            title="화학물질별 취급부서 목록"
            tableId="subsTable"
            :columns="gridsubs.columns"
            :data="chemList"
            :columnSetting="false"
            rowKey="mttrid"
            :filtering="false"
            :usePaging="false"
            :editable="editable"
            :hideBottom="true"
            gridHeight="400px"
            @linkClick="linkClick"
          >
            <template v-slot:customArea="{ props, col }">
              <template v-if="col.name === 'limitRepval'">
                <span>
                  {{props.row.limitRepval}}
                  <q-badge v-if="parseFloat(props.row.limitRepval) >= 1.00" color="negative" label="1%이상" class="blinking" />
                </span>
              </template>
              <template v-if="editable && col.name === 'deptNames' && props.row.deptList && props.row.deptList.length > 0">
                <q-chip
                  v-for="(item, idx) in props.row.deptList"
                  :key="idx"
                  :color="item.selected ? 'orange' : 'grey-6'"
                  :clickable="true"
                  :selected.sync="item.selected"
                  text-color="white"
                  icon="person_outline"
                  :label="item.processDeptName"
                  :title="item.processDeptName"
                  @click="btnDept(item)"
                >
                </q-chip>
              </template>
            </template>
          </c-table>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1" style="margin: auto 0; line-height: 35px; text-align:center;">
          <c-btn v-if="editable" label="선택추가" icon="arrow_forward_ios" color="blue-7" @btnClicked="selectAdd" />
          <c-btn v-if="editable" label="전체추가" icon="arrow_forward_ios" color="black" @btnClicked="allAdd" /><br><br>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-table
            ref="deptTable"
            title="유해인자 취급부서 목록"
            tableId="deptTable"
            :columns="grid.columns"
            :data="data.deptList"
            :columnSetting="false"
            selection="multiple"
            :isExcelDown="false"
            :editable="editable"
            rowKey="deptCd"
            :filtering="false"
            :usePaging="false"
            :hideBottom="true"
            gridHeight="400px"
          >
            <template slot="table-button">
              <q-btn-group outline >
                <c-btn label="추가" v-if="editable" icon="add" @btnClicked="addrow" />
                <c-btn label="제외" v-if="editable && data.deptList.length > 0" icon="remove" @btnClicked="removeRow" />
              </q-btn-group>
            </template>
          </c-table>
        </div> -->
      </div>
      <c-dialog :param="popupOptions"></c-dialog>
    </q-form>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'harmful-factors-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        hazardCd: '',
      }),
    },
  },
  data() {
    return {
      mappingType: 'POST',
      saveUrl: transactionConfig.sai.hazard.insert.url,
      insertUrl: '',
      updateUrl: '',
      deleteUrl: '',
      revlistUrl: '',
      chemName: '',
      checkUrl: '',
      subListUrl: '',
      subSaveUrl: '',
      subDeleteUrl: '',
      editable: true,
      isSave: false,
      isdelete: false,
      isRevision: false,
      updateMode: false,
      data: {
        hazardCd: '',
        hazardClassFstCd: null,
        hazardClassSecCd: null,
        hazardName: '',
        mdmChemMaterialId: '',
        useFlag: 'Y',
        mttrid: '',
        casNo: '',
        workEnvFlag: 'Y',
        speHealthFlag: 'Y',
        workMeasCycleCd: null,
        factorMeasCycleCd: null,
        regUserId: '',
        chgUserId: '',

        deptList: [],
      },
      chemList: [],
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      workFlagItems: [
        { code: 'Y', codeName: '관련' },
        { code: 'N', codeName: '미관련' },
      ],
      occSecItems: [],
      grid: {
        columns: [
          // {
          //   name: 'plantName',
          //   field: 'plantName',
          //   label: '사업장',
          //   align: 'center',
          //   style: 'width:100px',
          //   sortable: true,
          // },
          {
            name: 'deptCd',
            field: 'deptCd',
            label: '부서코드',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'deptName',
            field: 'deptName',
            label: '부서명',
            align: 'center',
            sortable: true,
          },
        ],
        data: [],
      },
      gridsubs: {
        columns: [
          {
            name: 'materialName',
            field: 'materialName',
            label: '화학자재',
            style: 'width:200px',
            type: 'link',
            align: 'left',
            sortable: false,
          },
          {
            name: 'limitRepval',
            field: 'limitRepval',
            label: '함유량(%) 대표값',
            type: 'custom',
            align: 'center',
            style: 'width:70px',
            sortable: false,
          },
          {
            name: 'deptNames',
            field: 'deptNames',
            label: '관련부서',
            style: 'width:350PX',
            type: 'custom',
            align: 'left',
            sortable: false,
          },
        ],
        data: [],
      },
      deptPushList: [],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.sai.hazard.get.url;
      this.detailDeptUrl = selectConfig.mdm.mam.chem.dept.url;
      this.insertUrl = transactionConfig.sai.hazard.insert.url;
      this.updateUrl = transactionConfig.sai.hazard.update.url;
      this.checkUrl = selectConfig.sai.hazard.check.url;

      this.subListUrl = selectConfig.sai.hazard.substance.list.url;
      // this.subSaveUrl = transactionConfig.sai.hazard.substance.save.url;
      // this.subDeleteUrl = transactionConfig.sai.hazard.substance.delete.url;
      this.getDetail();
    },
    getDetail() {
      if (this.popupParam.hazardCd) {
        this.$http.url = this.$format(this.detailUrl, this.popupParam.hazardCd);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.data = this.$_.clone(_result.data);
          this.setSecondItems(_result.data.hazardClassFstCd);
          this.getSubstanse();
          this.updateMode = true;
        },);
      }
    },
    getSubstanse() {
      if (this.data.casNo) {
        this.$http.url = this.subListUrl;
        this.$http.type = 'GET';
          this.$http.param = {
            casNo: this.data.casNo,
          };
        this.$http.request((_result) => {
          this.chemList = _result.data;
        },);
      }
    },
    linkClick(row) {
      this.openPop(row);
    },
    openPop(row) {
      this.popupOptions.title = '화학자재 상세';
      this.popupOptions.param = {
        mdmChemMaterialId: row ? row.mdmChemMaterialId : '',
        plantCd: row ? row.plantCd : '',
      };
      this.popupOptions.target = () => import(`${'@/pages/mdm/mam/chemDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getSubstanse();
    },  
    saveData() {
      if (this.popupParam.hazardCd) {
        this.saveUrl = this.updateUrl;
        this.mappingType = 'PUT';
      } else {
        this.saveUrl = this.insertUrl;
        this.mappingType = 'POST';
      }
      let saveMsg = '저장하시겠습니까?';
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          this.$http.url = this.checkUrl;
          this.$http.type = 'GET';
          this.$http.param = {
            mttrid: this.data.mttrid,
            hazardName: this.data.hazardName
          };
          this.$http.request((_result) => {
            if (_result.data > 0 && !this.updateMode) {
                window.getApp.$emit('ALERT', {
                  title: '안내', // 안내
                  message: '같은 유해인자가 존재합니다.',
                  type: 'warning', // success / info / warning / error
                });
                return;
            } else {
              window.getApp.$emit('CONFIRM', {
                title: '확인',
                message: saveMsg,
                // TODO : 필요시 추가하세요.
                type: 'info', // success / info / warning / error
                // 확인 callback 함수
                confirmCallback: () => {
                  this.data.regUserId = this.$store.getters.user.userId;
                  this.data.chgUserId = this.$store.getters.user.userId;

                  this.isSave = !this.isSave;
                },
                // 취소 callback 함수
                cancelCallback: () => {
                },
              });
            }
          },);
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.popupParam.hazardCd = result.data
      this.getDetail();
    },
    setSecondItems(hazardClassFstCd) {
      this.$http.url = this.$format(selectConfig.sys.code.mst.list.attr.url, 'HAZARD_CLASS_SEC_CD', hazardClassFstCd);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.occSecItems = [];
        this.$_.forEach(_result.data, _item => {
          this.occSecItems.splice(0, 0, {
            code: _item.code,
            codeName: _item.codeName,
          })
        })
      },);
    },
    addrow() {
      this.popupOptions.title = '취급부서 추가';
      this.popupOptions.param = {
        plantCd: this.data.plantCd
      }
      this.popupOptions.target = () => import(`${'@/pages/common/dept/deptMultiPop.vue'}`);
      this.popupOptions.width = '40%';
      this.popupOptions.isFull = false;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeDept;
    },
    closeDept(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.data.deptList, { deptCd: item.deptCd }) === -1) {
            this.data.deptList.push({
              mdmChemMaterialId: this.data.mdmChemMaterialId,
              hazardCd: this.popupParam.hazardCd,
              deptCd: item.deptCd,
              deptName: item.deptName,
              editFlag: 'C',
            })
          }
        })
      }
    },
    removeRow() {
      let selectData = this.$refs['deptTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          this.data.deptList = this.$_.reject(this.data.deptList, item)
        })
      }
    },
    addApiRow() {
      this.popupOptions.target = () => import(`${'@/pages/common/openapi/materialApiPop.vue'}`);
      this.popupOptions.title = '환경부-화학물질정보 연동 검색';
      this.popupOptions.width = '50%';
      this.popupOptions.param = {
        type: 'single'
      }
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopupApi;
    },
    closePopupApi(_data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if(_data) {
        this.$_.forEach(_data, item => {
          this.data.casNo = item.casno;
          this.data.chemName = item.mttrnmkor;
          this.data.mttrid = item.mttrid;
        });
        this.getSubstanse()
      }
    },
    removeHazard() {
      this.data.mdmChemMaterialId = '';
      this.data.hazardCd = '';
      this.data.materialCd = '';
      this.data.casNo = '';
      this.data.hazardName = '';
      this.data.checmName = '';
      
      this.data.hazardClassSecCd = null;
      this.setSecondItems(this.data.hazardClassFstCd)
    },
    selectAdd() {
      this.$refs['deptTable'].selected = [];
      let selectData = this.deptPushList;
      this.$_.forEach(selectData, (item) => {
        if (this.$_.findIndex(this.data.deptList, { deptCd: item.deptCd }) === -1) {
          this.data.deptList.push({
            mdmChemMaterialId: this.data.mdmChemMaterialId,
            hazardCd: this.popupParam.hazardCd,
            deptCd: item.deptCd,
            deptName: item.deptName,
            editFlag: 'C',
          })
        }
        this.grid.data = this.$_.reject(this.grid.data, item)
      })
    },
    allAdd() {
      if (!this.data.deptList) {
        this.data.deptList = [];
      }
      this.$_.forEach(this.chemList, _item => {
        this.$_.forEach(_item.deptList, __item => {
          if (this.$_.findIndex(this.data.deptList, { deptCd: __item.processDeptCd }) === -1) {
            this.data.deptList.push({
              mdmChemMaterialId: this.data.mdmChemMaterialId,
              hazardCd: this.popupParam.hazardCd,
              deptCd: __item.processDeptCd,
              deptName: __item.processDeptName,
              editFlag: 'C',
            })
          }
        })
      })
    },
    btnDept(item) {
      this.$_.forEach(this.chemList, _item => {
        this.$_.forEach(_item.deptList, __item => {
          if (__item.processDeptCd === item.processDeptCd) {
            __item.selected = item.selected;
          }
        })
      })
      if (item.selected) {
        this.deptPushList.push({
          mdmChemMaterialId: this.data.mdmChemMaterialId,
          hazardCd: this.popupParam.hazardCd,
          deptCd: item.processDeptCd,
          deptName: item.processDeptName,
          editFlag: 'C',
        })
      } else {
        this.deptPushList = this.$_.reject(this.data.deptPushList, { deptCd: item.processDeptCd })
      }
    },
    datachange() {
      this.removeHazard();
    },
    datachange1(_data) {
      if (_data.value) {
        this.data.workEnvFlag = 'Y'
      } else {
        this.data.workEnvFlag = 'N'
      }
    },
    datachange2(_data) {
      if (_data.value) {
        this.data.speHealthFlag = 'Y'
      } else {
        this.data.speHealthFlag = 'N'
      }
    },
  }
};
</script>
